module.exports = __webpack_public_path__ + "static/media/organic.2264060d.svg";